var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"MainSite"},[(!_vm.$SALE_ID)?_c('Login'):_vm._e(),(_vm.$SALE_ID)?_c('Menu'):_vm._e(),_c('div',{staticClass:"mt-5"},[(_vm.$SALE_ID)?_c('router-view',{key:_vm.$KEY}):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }